const template = require('./dashboard_stacked_chart.html.slim');
const controller = require('./dashboard_stacked_chart_controller');

angular.module('wbComponents').directive(
  'wbDashboardStackedChart',
  () => (
    {
      restrict: 'E',
      replace: true,
      controller,
      controllerAs: 'ctrl',

      scope: {
        results: '<data',
        columns: '<',
        horizontalTicks: '@'
      },

      bindToController: true,
      templateUrl: template
    }
  )
);
